import React from "react";
import { withStyles } from "@mui/styles";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

import Label from "../label/Label";

const styles = (theme) => ({
  timePickerInput: {
    marginBottom: "10px",
    width: "246px",
  },
  invalidInput: {
    "& .MuiOutlinedInput-root": {
      border: "1px solid red",
    },
  },
});

function TimePickerInput({
  classes,
  style,
  value,
  label,
  showInvalidInput,
  onChange,
  required,
}) {
  return (
    <div
      className={`${classes.timePickerInput} ${
        showInvalidInput ? classes.invalidInput : ""
      }`}
      style={style || {}}
    >
      {label && <Label title={label} required={required} />}
      <TimePicker
        value={value}
        onChange={onChange}
        ampm={false}
        minutesStep={5}
        slotProps={{
          textField: {
            fullWidth: true,
            variant: "outlined",
            error: showInvalidInput,
            helperText: showInvalidInput ? "Invalid time" : "",
          },
        }}
      />
    </div>
  );
}

export default withStyles(styles)(TimePickerInput);
